module.exports = __webpack_public_path__ + "img/prize4.6a9ab02e.png";